import { useTenant } from '@providers/Tenant';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { ConfigurationsService } from '../api/configurationsService';

export function useConfiguration(configurationPID: string) {
  const { accountId } = useTenant();
  const service = useMemo(() => new ConfigurationsService(), []);

  const { data, ...rest } = useQuery({
    queryKey: ['configuration', configurationPID],
    queryFn: () => service.get(accountId, configurationPID),
  });

  return { data: data?.payload, ...rest };
}
